import { render, staticRenderFns } from "./addOrderToRegion.vue?vue&type=template&id=026fa468&scoped=true"
import script from "./addOrderToRegion.vue?vue&type=script&lang=js"
export * from "./addOrderToRegion.vue?vue&type=script&lang=js"
import style0 from "./addOrderToRegion.vue?vue&type=style&index=0&id=026fa468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026fa468",
  null
  
)

export default component.exports